import React, { useMemo } from "react"
import { useHistory } from "react-router-dom"
import SButton from "components/Common/Button"
import TableContainer from "components/newTables/TableContainer"

const Table = ({ content, page, size, count, params, setParams }) => {
  const history = useHistory()

  const listDataTable = useMemo(() => {
    if (!content) return []
    return content.map((v, i) => ({
      id: v.id,
      categoryName: v?.categoryName,
      productName: v?.productName || "-",
      item: v?.item,
      format: v?.format,
    }))
  }, [content])

  const columns = useMemo(
    () => [
      {
        Header: "商品カテゴリ",
        accessor: "categoryName",
        defaultCanSort: false,
      },
      {
        Header: "商品名",
        accessor: "productName",
        defaultCanSort: false,
      },
      {
        Header: "項目",
        accessor: "item",
        defaultCanSort: false,
      },
      {
        Header: "形式",
        accessor: "format",
        defaultCanSort: false,
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(
                  `/master/specification/create?id=${cell.row.original.id}`
                )
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  return content?.length === 0 ? (
    <h3 className="text-center">No Data to Display</h3>
  ) : (
    <TableContainer
      page={page}
      size={size}
      count={count}
      setParams={setParams}
      params={params}
      columns={columns}
      data={listDataTable}
      pagination
    />
  )
}

export default Table
